import React from 'react';
import { makeStyles, Link } from '@material-ui/core';
import { useTranslation } from 'react-i18next'; 

const useStyles = makeStyles({
    root: {
        fontSize: "1rem"
    },
    link: {
        color: "#4F3CC9",
        
    },
})

interface ITermsOfService {
    text:string
}
const TermsOfService = ({text}:ITermsOfService) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <p className={classes.root}>
            {`${t("signup.form.terms_intro")} `}
            <Link 
                className={classes.link}
                href={"https://y-e.co/terms/MerchantAgreement.pdf"} 
                rel="noopener noreferrer" 
            >{t(`signup.form.${text}`)}</Link>
        </p>
    )
}

export default TermsOfService;